// src/App.js
import { useState } from "react";
import Navbar from "./components/Navbar";
import './App.css';
import { BrowserRouter as Router } from 'react-router-dom';
import HeroSection from "./components/HeroSection";
import About from "./components/About";
// import Tech from "./components/Tech";
import Skills from "./components/Skills";
import Projects from "./components/Projects";
import Publications from "./components/Publications";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Experience from "./components/Experience";
import Education from "./components/Education";
import ProjectDetails from "./components/ProjectDetails";
import styled from "styled-components";
import { StarsCanvas } from "./components/canvas";

const Body = styled.div`
  background-color: ${({ theme }) => theme.colors.background1};
  color: ${({ theme }) => theme.colors.text};
  width: 100%;
  overflow-x: hidden;
  padding-top: 80px;
  position: relative;
  z-index: 1;
  min-height: 100vh;
  box-sizing: border-box;
  clip-path: inset(80px 0px 0px 0px);
`;

const Wrapper = styled.div`
  background: linear-gradient(38.73deg, rgba(204, 0, 187, 0.15) 0%, rgba(201, 32, 184, 0) 50%), 
              linear-gradient(141.27deg, rgba(0, 70, 209, 0) 50%, rgba(0, 70, 209, 0.15) 100%);
  width: 100%;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 30% 98%, 0 100%);
  @media (max-width: 480px) {
    clip-path: none;
  }
`;

function App() {
  const [openModal, setOpenModal] = useState({ state: false, project: null });

  return (
    <Router>
      <StarsCanvas />
      <Navbar />
      <Body>
        <HeroSection />
        <About />
        {/* <Tech /> */}
        <Wrapper>
          <Skills />
          <Experience />
        </Wrapper>
        <Projects openModal={openModal} setOpenModal={setOpenModal} />
        <Wrapper>
          <Publications />
          <Education />
          <Contact />
        </Wrapper>
        <Footer />
        {openModal.state &&
          <ProjectDetails openModal={openModal} setOpenModal={setOpenModal} />
        }
      </Body>
    </Router>
  );
}

export default App;
